import { Box, Banner, Typography } from "@bca/ui-library";
import { useContext } from "react";
import { ErrorContext } from "../../../../src/context/ErrorContext";

const ErrorBanner = () => {
  const errorContext = useContext(ErrorContext);

  return (
    <Box
      width="100%"
      css={`
        position: fixed;
        bottom: 40px;
        left: 0;
        z-index: 20;
      `}
    >
      <Box
        width="95%"
        margin="0 auto"
        css={`
          position: relative;
          max-width: 1100px;
          box-shadow: 0px 3px 25px rgba(103, 103, 103, 0.370302);
          border-radius: 6px;
        `}
      >
        <Banner
          title="Services Unavailable"
          variant="warning"
          primaryLinkLabel="Dismiss"
          primaryLinkAction={() => {
            errorContext?.dispatch({ type: "clear" });
          }}
          displayMode="inline"
        >
          <Typography margin={0} variant="body">
            We are unable to track, save searches or surface notes at the
            moment. Please try again later.
          </Typography>
        </Banner>
      </Box>
    </Box>
  );
};

export default ErrorBanner;
